import { LeftOutlined } from "@ant-design/icons";
import Divider from "@/shared/layout/divider";
import theme from "@/shared/theme";
import { useState } from "react";
import { twMerge } from "tailwind-merge";
import Card from "@/shared/data-display/card";
import Sider from "@/shared/layout/sider";
import Menu from "@/shared/navigation/menu";
import Text from "@/shared/typography/text";
import { useNavigationItems } from "../model/use-navigation-items";
import { useTranslations } from "use-intl";

const { useToken } = theme;

export function Navigation() {
  const t = useTranslations("Navigation");
  const { token } = useToken();
  const [collapsed, setCollapsed] = useState(false);

  const toggle = () => {
    setCollapsed((c) => !c);
  };

  const items = useNavigationItems();

  return (
    <Sider
      width="210px"
      collapsible
      collapsed={collapsed}
      trigger={null}
      className="rounded-lg"
    >
      <Card
        styles={{
          body: {
            padding: 0,
          },
        }}
        className="xl:max-h-[--navigation-height] xl:overflow-auto"
      >
        <div className="p-4 pb-2">
          <Menu items={items} className="!border-0" />
        </div>
        <Divider style={{ margin: 0 }} />

        <button className="py-3 px-6 overflow-hidden w-full" onClick={toggle}>
          <div className="flex items-center space-x-2 w-min">
            <LeftOutlined
              className={twMerge(
                "w-8 h-8 flex grow justify-center items-center rounded-md",
              )}
              rotate={collapsed ? 180 : 0}
              style={{
                background: token.Menu?.itemHoverBg,
                color: token.colorPrimary,
              }}
            />
            <Text
              as="span"
              type="body2"
              className={twMerge("text-ellipsis", collapsed && "!hidden")}
              style={{ color: token.colorPrimary }}
              firstCapitalize
            >
              {t("collapse")}
            </Text>
          </div>
        </button>
      </Card>
    </Sider>
  );
}
